// UnityUrlHandler.tsx
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

// 1) Универсальная безопасная попытка открытия окна.
//    Возвращает true, если окно открыто, иначе false (поп‑ап заблокирован).
function tryOpen(url: string, target: string = '_blank'): boolean {
  const w = window.open('', target);
  if (!w) return false;
  try {
    w.location.href = url;
    return true;
  } catch {
    w.close?.();
    return false;
  }
}

export const UnityUrlHandler: React.FC = () => {
  const { t } = useTranslation();
  const [pendingUrl, setPendingUrl] = useState<string | null>(null);

  // 2) Подписка на событие от Unity
  useEffect(() => {
    const handler = (e: any) => {
      const url: string = e?.detail?.url;
      if (!url) return;

     

      // Сначала пробуем открыть сразу (в идеале — без модалки)
      const opened = tryOpen(url, '_blank');
      if (!opened) setPendingUrl(url);
    };

    window.addEventListener('UnityOpenURL', handler);
    return () => window.removeEventListener('UnityOpenURL', handler);
  }, []);

  // 3) Закрытие по ESC
  useEffect(() => {
    if (!pendingUrl) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setPendingUrl(null);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [pendingUrl]);

  if (!pendingUrl) return null;

  return (
    <div style={overlayStyle} role="dialog" aria-modal="true">
      <div style={cardStyle} onClick={(e) => e.stopPropagation()}>
        <button
          onClick={() => {
            const ok = tryOpen(pendingUrl!, '_blank');
            if (ok) setPendingUrl(null);
            else console.error('Поп‑ап заблокирован повторно');
          }}
          style={buttonStyle}
          aria-label={t('unityUrlHandler.buttonText')}
        >
          {/* SVG‑иконка */}
          <svg
            width="100" height="100" viewBox="0 0 48 48"
            xmlns="http://www.w3.org/2000/svg" role="img" focusable="false"
          >
            <defs>
              <style>{`.a{fill:none;stroke:white;stroke-linecap:round;stroke-linejoin:round;}`}</style>
            </defs>
            <path className="a" d="M21.4429,29.8271v5.487c-2.1129-1.22-9.03-1.8194-5.5713,2.2735S20.9888,43.5,22.3521,43.5H33.1536c2.0465,0,1.9325-5.7983,2.5016-7.6178s.5681-3.6388-1.4784-4.434c-1.3107-.51-2.912-1.7609-4.7235-2.5977"/>
            <path className="a" d="M16.61,17.2924a7.3908,7.3908,0,1,1,9.6077,7.014v3.73a7.7456,7.7456,0,0,1,3.2353.8131,12.7724,12.7724,0,1,0-8.0124.9766V24.2a7.3725,7.3725,0,0,1-4.8316-6.9088Z"/>
            <path className="a" d="M31.3917,17.2924a7.3907,7.3907,0,1,0-9.95,6.9089v-5.146a2.394,2.394,0,1,1,4.7751,0v5.2521a7.3658,7.3658,0,0,0,5.1737-7.014Z"/>
            <path className="a" d="M26.218,24.3074V19.0553a2.394,2.394,0,1,0-4.7751,0в5.146"/>
          </svg>
        </button>

        {/* Кнопка закрыть по желанию
        <div style={{ marginTop: 12 }}>
          <button onClick={() => setPendingUrl(null)} style={closeBtnStyle}>
            {t('unityUrlHandler.close') || 'Закрыть'}
          </button>
        </div> */}
      </div>

      {/* Клик по фону закрывает модалку */}
      <div style={backdropCatch} onClick={() => setPendingUrl(null)} />
    </div>
  );
};

// Стили
const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999
};
const backdropCatch: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,.6)'
};
const cardStyle: React.CSSProperties = {
  position: 'relative',
  backgroundColor: '#fff',
  padding: '5px',
  borderRadius: '20px',
  textAlign: 'center',
  maxWidth: '300px',
  zIndex: 10000
};
const buttonStyle: React.CSSProperties = {
  backgroundColor: '#eb8896',
  border: 'none',
  borderRadius: '20px',
  color: 'white',
  padding: '10px 10px',
  cursor: 'pointer',
  fontSize: '22px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px'
};
const closeBtnStyle: React.CSSProperties = {
  background: 'transparent',
  border: 'none',
  color: '#666',
  cursor: 'pointer',
  fontSize: 14,
  textDecoration: 'underline'
};

export default UnityUrlHandler;
